module.exports = __webpack_public_path__ + "static/media/lbcj3.5673253b.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/lbcj3.png
// module id = 559
// module chunks = 0